// 17/05/2025 Modificado showInput
// 22/05/2025 Añadido iniciarTabsComponentes
//              Añadido refSiguienteTabValido
//              Modificado onKeyDown
// 23/05/2025 Añadido onVisible en las secciones y su gestión en showSecciones.
// 28/05/2025 Modificado changeElemento para pasar a mayusculas: valueReal= value.toUpperCase();
// 02/06/2025 Añadida función showEspacio
//            Modificada función showCampo para tener en cuenta la propiedad  noVisibleMostrarEspacio y la función anterior.
//22/06/2025
//   Cambios en showInputBusqueda para onKeyPRess
//   cambios en propiedades de Grid

// 28/08/2025 Añadido método postServicio
// 04/09/2025 Modificado el método changeElemento para tener en cuenta campo.maxTamagno
//            Modificado showInput para tener maxLength: campo.maxTamagno
//            Añadido en ShowMemo para tener rows:
// 11/09/2025 Modificado showCodigoId, para que el onChange monte el objeto event que se pasa.
// 12/09/2025 Creado método loadDatosServicio
// 20/09/2025 Modificado método loadDatosServicio para tener callbackError
// 23/09/2025 Creado método handleDelete para el nuevo eliminar que llama al servicio
//            Modificado RenderTabla para llamar al nuevo metodo handleDelete en onEliminar
//            Añadido a showInputBusqueda el parametro ref.
// 16/12/2025 Modificado ShowDate
// 26/12/2025 En gridOnDobleClick añadido nuevo parametro para funciones directas
// 30/12/2025 Añadido postServicioBloqueante

import React, {createRef} from "react";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {servicioRestfulCompleto, servicioRestfulMinimo, servidor} from "../Configuracion";
import {posPrimerElementoConValorPropiedad, primerElementoCodigo} from "../../framework2/ej2/utils/ArrayUtils";
import MultiSelect from "../../framework2/ej2/UI/MultiSelect";
import SelectorListaClaseObjeto from "../../framework2/ej2/UI/SelectorListaClaseObjeto";
import {Intent, Spinner} from "@blueprintjs/core";
import GridRDG from "../../framework2/adazzle/GridRDG";
import FormularioBotonera, {
    BOTONERA_ACCION_EXCEL,
    BOTONERA_ACCION_NUEVO,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import {calcularDatosConPie} from "../../framework2/ej2/utils/DatosUtils";
import {exportarExcelLocal} from "../../framework2/ej2/utils/ExportarUtils";
import SelectorFechaHora from "../../framework2/ej2/UI/SelectorFechaHora";
import SelectorClaseObjeto from "../../framework2/ej2/UI/SelectorClaseObjeto";
import InputFlotante from "../../framework2/ej2/UI/InputFlotante";
import InputCodigoId from "../../framework2/ej2/UI/InputCodigoId";
import Tabla from "../../framework2/ej2/UI/Tabla";
import AvisoModalServicio from "../../framework2/ej2/UI/AvisoModalServicio";
import InputFechaV3 from "../../framework2/ej2/UI/InputFechaV3";
import {getFormattedDateFromTimestamp} from "../../framework2/ej2/utils/DateUtils";
import InputFecha from "../../framework2/ej2/UI/InputFecha";
import InputIdFiscal from "../../framework2/ej2/UI/InputIdFiscal";
import InputPoblacion from "../../framework2/ej2/UI/InputPoblacion";
import InputTextArea from "../../framework2/ej2/UI/InputTextArea";
import {confirmar} from "../../framework2/ej2/UI/ConfirmadorServicio";
import InputColor from "../../framework2/ej2/UI/InputColor";
import HTMLEditorQuill from "../../framework2/ej2/UI/HTMLEditorQuill";
import HTMLEditorTinyMCE from "../../framework2/ej2/UI/HTMLEditorTinyMCE";
import InputTexto from "../../framework2/ej2/UI/InputTexto";

export const COMPONENTE_TIPO_INPUT= 'COMPONENTE_TIPO_INPUT';
export const COMPONENTE_TIPO_FLOTANTE= 'COMPONENTE_TIPO_FLOTANTE';
export const COMPONENTE_TIPO_SELECT= 'COMPONENTE_TIPO_SELECT';
export const COMPONENTE_TIPO_SELECT_MULTI= 'COMPONENTE_TIPO_SELECT_MULTI';
export const COMPONENTE_TIPO_MEMO= 'COMPONENTE_TIPO_MEMO';
export const COMPONENTE_TIPO_MEMO_OCULTABLE = 'COMPONENTE_TIPO_MEMO_OCULTABLE';
export const COMPONENTE_TIPO_DATE= 'COMPONENTE_TIPO_DATE';
export const COMPONENTE_TIPO_DATETIME= 'COMPONENTE_TIPO_DATETIME';
export const COMPONENTE_TIPO_BOOL= 'COMPONENTE_TIPO_BOOL';
export const COMPONENTE_TIPO_FOREIGN= 'COMPONENTE_TIPO_FOREIGN';
export const COMPONENTE_TIPO_FOREIGN_SERVIDOR = 'COMPONENTE_TIPO_FOREIGN_SERVIDOR';
export const COMPONENTE_TIPO_FOREIGN_PANTALLA = 'COMPONENTE_TIPO_FOREIGN_PANTALLA";'
export const COMPONENTE_TIPO_CODIGOID = 'COMPONENTE_TIPO_CODIGOID';
export const COMPONENTE_TIPO_FECHA = 'COMPONENTE_TIPO_FECHA';
export const COMPONENTE_TIPO_IDFISCAL = 'COMPONENTE_TIPO_IDFISCAL';
export const COMPONENTE_TIPO_POBLACION = 'COMPONENTE_TIPO_POBLACION';
export const COMPONENTE_TIPO_COLOR = 'COMPONENTE_TIPO_COLOR';

export const COMPONENTE_TIPO_HTML= 'COMPONENTE_TIPO_HTML';

export const getValorCampo= (elemento, nombreCampo, valorDefecto = undefined) => {
    if (!elemento)
        return "";
    //console.log("elemento:", elemento);
    //console.log("nombreCampo: ", nombreCampo);
    return nombreCampo.split('.')
        .reduce((acc, subcampo) =>  acc && acc[subcampo] !== undefined ? acc[subcampo] : valorDefecto
            , elemento);
}
export const setValorCampo= (elemento, nombreCampo, newValor) => {
    if (!elemento)
        return;

    const keys = nombreCampo.split('.');
    let current = elemento;

    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        // Si la propiedad no existe o no es un objeto, la creamos como un objeto vacío
        if (!current[key] || typeof current[key] !== 'object') {
            current[key] = {};
        }
        current = current[key]; // Avanzamos al siguiente nivel
    }

    // Asignamos el nuevo valor en la última clave
    current[keys[keys.length - 1]] = newValor;
}

const changeElemento = (componente, campo, event, objectForeign, callbackSetState) => {
    const {elemento} = componente.state;
    //console.log("event: ", event);
    const { name, value} = event.target;


    console.log(" --- changeElemento ---- ");
    //console.log("componente: ", componente);
    //console.log("event: ", event);
    //console.log("name: ", name);
    console.log("campo: ", campo);
    console.log("value: ", value);
    //console.log("elemento: ", elemento);
    //console.log("objetoForeign: ", objectForeign);
    //console.log("campo.nomayus: ", campo.nomayus);

    let newElemento= {...elemento};
    let valueReal =  value;

    if (campo.nomayus == undefined)
        valueReal=  typeof value === 'string' ?  value.toUpperCase() : value;
    else
        valueReal=  typeof value === 'string' ?  value.toLowerCase() : value;

    if(campo.maxTamagno && campo.maxTamagno > 0 && valueReal.length > campo.maxTamagno)
        valueReal = valueReal.substring(0, campo.maxTamagno);

    if (objectForeign)
        valueReal= objectForeign;
    setValorCampo(newElemento, name, valueReal);
    console.log("newElemento modificado en changeElemento: ", newElemento);

    if (campo.onChange) {
        let newElementoModificado = campo.onChange(newElemento);
        //Si no devuelve nada el onChange, se deja el elementoOriginal.
        if (newElementoModificado)
            newElemento= newElementoModificado
    }

    console.log("newElemento modificado DESPUÉS ONCHANGE: ", newElemento);

    componente.setState({elemento: newElemento}, () => {
        callbackSetState && callbackSetState()
    });
};

const changeMoneda = (componente, campo, newRawValue) => {
    const {elemento} = componente.state;
    let newElemento= {...elemento};
    setValorCampo(newElemento, campo.campo, newRawValue);
    if (campo.onChange)
        newElemento= campo.onChange(newElemento);
    componente.setState({elemento: newElemento});
};


const changeSelect = (componente, campo, event) => {
    const {elemento} = componente.state;
    const { name, value} = event.target;

    console.log("XXXXX ChangeSelect");
    console.log("name: ", name);
    console.log("value: ", value);


    let newElemento= {...elemento};
    let valueReal= Number(value);
    setValorCampo(newElemento, name, valueReal);
    console.log("newElemento", newElemento);
    componente.setState({elemento: newElemento});
};

const changeCheck = (componente, campo, event) => {
    const {elemento} = componente.state;
    const { name, checked } = event.target;

    let newElemento= {...elemento};
    setValorCampo(newElemento, name, checked);
    console.log("newElemento", newElemento);

    componente.setState({elemento: newElemento});
};

const changeDateTime = (componente, campo, dtDatetime) => {
    const {elemento} = componente.state;
    let newElemento= {...elemento};
    //console.log(">>> changeDateTime <<<");
    //console.log("campo: ", campo);
    setValorCampo(newElemento, campo.campo, dtDatetime);
    //console.log ("newElemento: ", newElemento);

    if (campo.onChange) {
        let newElementoModificado = campo.onChange(newElemento);
        //Si no devuelve nada el onChange, se deja el elementoOriginal.
        if (newElementoModificado)
            newElemento= newElementoModificado;
        //console.log("newElementoModificado: ", newElementoModificado);
    }
    componente.setState({elemento: newElemento});
};

// -------------------------------------------------------------------------------------------------------------------
// USO DEL TAB
// -------------------------------------------------------------------------------------------------------------------

//Para ue funcione correctamente, se debe limpiar el array Tabs y generarse en cada Render
export const onKeyDown = (componente, event, posicionTab) => {
    if (event.key === "Enter") {
        event.preventDefault(); // Evita que se envíe el formulario
        let refSiguiente= refSiguienteTabValido(componente, posicionTab);
        if (refSiguiente)
            refSiguiente.current.focus();
    }
};

export const refSiguienteTabValido = (componente, posicionTab) => {
    if (!componente.tabs)
        return null;

    //let siguientePosicionTab = (posicionTab + 1) % componente.tabs.length;
    let siguientePosicionTab = (posicionTab + 1);
    if (siguientePosicionTab > componente.tabs.length)
        siguientePosicionTab= 1;

    let refEncontrado= null;
    while (!refEncontrado && siguientePosicionTab != posicionTab) {
        //let ref = componente.tabs[siguientePosicionTab];
        let ref= getTab(siguientePosicionTab, componente);
        if (ref && ref.current)
            refEncontrado= ref;
        else{
            //siguientePosicionTab = (siguientePosicionTab + 1) % componente.tabs.length;
            siguientePosicionTab = (siguientePosicionTab + 1);
            if (siguientePosicionTab > componente.tabs.length)
                siguientePosicionTab= 1;
        }
    }
    return refEncontrado;
}
// -------------------------------------------------------------------------------------------------------------------
// TABS
// -------------------------------------------------------------------------------------------------------------------


const getTab= (posicionTab, componente) => {
    if (posicionTab){
        return componente.tabs[posicionTab-1]; //Restamos uno pq los tab empiezan por 1 pero las posiciones del Array por 0
    }
}

const getMaximoTab= (elementoConfig) => {
    //Recorremos todos los campos y obtenemos el mayor tab
    let maxTab= 0;
    for (const seccion of elementoConfig.secciones) {
        for (const campo of seccion.campos) {
            let tab= campo.tab ? campo.tab : 0;
            if (tab > maxTab )
                maxTab= tab;
        }
    }
    return maxTab;
}

export const iniciarTabs= (elementoConfig) => {
    let numElementos= getMaximoTab(elementoConfig);
    let tabs = Array.from({ length: numElementos }, () => createRef());
    return tabs;
}

export const iniciarTabsComponentes= (elementoConfig) => {
    //REcorremos todos los componenes en orden asignandoles el valor tab
    let pos= 1;
    for (const seccion of elementoConfig.secciones) {
        for (const campo of seccion.campos) {
            campo.tab= pos;
            console.log("campo.campo: ",  campo.campo, "->", campo.tab);
            pos++;
        }
    }
}

//El componente debe tener elementoConfig y se le inyecta un this.tabs
export const inicializarTabs= (componente) => {
    iniciarTabsComponentes(componente.elementoConfig);
    componente.tabs = iniciarTabs(componente.elementoConfig);
}

// -------------------------------------------------------------------------------------------------------------------
// RENDER
// -------------------------------------------------------------------------------------------------------------------

//Elementos que deben existir en el componente padre (componente)
//  elementoConfig y onFormularioAceptado en el this.
//  elementoSeleccionado en el state.
export const renderFormulario= (componente, componenteFormulario) => {
    const {elementoSeleccionado} = componente.state;
    const componenteFormularioAmpliado = React.cloneElement(componenteFormulario, {
        elementoConfig: componente.elementoConfig,
        elemento: elementoSeleccionado,
        onAceptar: componente.onFormularioAceptado,
        onCancelar: componente.onFormularioCancelado ? componente.onFormularioCancelado : () => componente.setState({showGrid: true}),
    });

    return (
        <>
            { elementoSeleccionado && componenteFormularioAmpliado}
        </>
    );
}




//Elementos que deben existir en el componente padre (componente)
//  elementoConfig en el this.
//  elementoSeleccionado, cargandoDatos, marcaTiempo en el state.
export const renderGrid= (componente, titulo, datos, onAccion, propiedades, columnas = null) => {
    const {cargandoDatos, marcaTiempo, elementoSeleccionado} = componente.state;

    let mostrarEliminar= true;
    let mostrarBotonNuevo= true;
    let estilizadorRow= undefined;
    if (propiedades){
        if (propiedades.mostrarEliminar !== undefined)
            mostrarEliminar= Boolean(propiedades.mostrarEliminar);
        if (propiedades.mostrarBotonNuevo !== undefined)
            mostrarBotonNuevo= Boolean(propiedades.mostrarBotonNuevo);
        estilizadorRow=propiedades.estilizadorRow;
    }

    let showAcciones=[BOTONERA_REFRESCAR, BOTONERA_ACCION_EXCEL];
    if (Boolean(mostrarBotonNuevo))
        showAcciones.push(BOTONERA_ACCION_NUEVO);

    let mostrarBotonera= true;
    if (propiedades && propiedades.mostrarBotonera !== undefined)
        mostrarBotonera= Boolean(propiedades.mostrarBotonera);

    let gridHeight= 600;
    if (propiedades && propiedades.height !== undefined)
        gridHeight= propiedades.height;

    //console.log(">>>> RENDERGRID");
    //console.log("componente: ", componente);
    //console.log("columnas: ", componente.columnas);

    let onElementoSeleccionado= propiedades ? propiedades.onElementoSeleccionado : null;
    //let onEliminar = propiedades ? propiedades.onEliminar : null;

    let onDobleClick = propiedades ? propiedades.onDobleClick : null;

    let columnasReal= columnas ? columnas : componente.columnas;
    return (
        <>
            {cargandoDatos &&  <Spinner intent={Intent.PRIMARY} size={50} /> }
            {(!cargandoDatos && datos) &&
                <>
                    <GridRDG titulo= {titulo}
                             marcaTiempo= {marcaTiempo}
                             columnas={columnasReal}
                             datos={datos}
                             editable={true}
                             estilo={{height: gridHeight}}
                             rowKey={"codigo"}
                             onSelectedRow={(elemento) => {
                                 componente.setState({elementoSeleccionado: elemento});
                                 onElementoSeleccionado && onElementoSeleccionado(elemento);
                             }}
                        //onDobleClick={componente.onDobleClick}
                             showFiltroEncabezado= {true}
                             showBuscador= {false}
                             nivel= "nivel"

                             mostrarEliminar={mostrarEliminar}
                             onRowModificada={
                                 (objetoOld, objetoNew, rowIndex, callback) => {
                                     //console.log("<<< ON ROWMODIFICADA >>> ");
                                     //console.log("objetoOld: ", objetoOld);
                                     //console.log("objetoNew: ", objetoNew);
                                     //console.log("rowIndex: ", rowIndex);
                                     //console.log("componente.elementoConfig: ", componente.elementoConfig);
                                     onRowModificada(componente, objetoNew, rowIndex, callback);
                                 }
                             }

                             onEliminar={(accion, elemento) => handleDelete(componente, accion, elemento)}
                             estilizadorRow={(elemento) => { return gridEstilizadorRow(componente, propiedades, elemento)  }}
                             //onDobleClick={(info) => gridOnDobleClick(componente, info)}
                             onDobleClick={(info) => gridOnDobleClick(componente, info, onDobleClick)}
                    />
                    {Boolean(mostrarBotonera)&&
                        <FormularioBotonera
                            numElementos={datos ? datos.length : 0}
                            showAcciones={showAcciones}
                            onAccion={onAccion}
                            elementoSeleccionado={elementoSeleccionado}
                        />
                    }
                </>
            }
        </>
    );

}



const handleDelete = async (componente, accion, elemento) => {
    componente.setState({elementoSeleccionado: elemento});

    const confirmado = await confirmar({
        message: "¿Deseas eliminar este registro?",
        okText: "Eliminar",
        cancelText: "Cancelar",
        okStyle: { backgroundColor: "red" },
        cancelStyle: { backgroundColor: "gray" }
    });

    if (!confirmado) return;

    console.log("handleDelete: componente:", componente);

    if (componente.eliminarElemento) {
        if (componente.comprobarElementoEliminar) {
            if (await componente.comprobarElementoEliminar()) {
                console.log("SE PUEDE ELIMINAR");
                componente.eliminarElemento();
            }
        } else {
            componente.eliminarElemento();
        }
    }

    /*
    if (accion)
        componente.eliminarElemento(accion, elemento);
    else
        componente.eliminarElemento(elemento);
    */

};


const gridEstilizadorRow= (componente, propiedades, elemento) => {
    const {elementoDestacadoCodigo} = componente.state;
    let estilizadorRowExterno= propiedades && propiedades.estilizadorRow;

    /*
    console.log("+ gridEstilizadorRow");
    console.log("estilizadorRowExterno: ", estilizadorRowExterno);
    console.log("elemento: ", elemento);
    console.log("elementoDestacadoCodigo: ", elementoDestacadoCodigo);
    */
    //Esto manda sobre los demás criterios:
    if (elementoDestacadoCodigo == elemento.codigo)
        return {backgroundColor: '#b5eff5'};
    if (estilizadorRowExterno)
        return estilizadorRowExterno(elemento);
};

const gridOnDobleClick= (componente, info, onDobleClick) => {
    console.log (">>> gridOnDobleClick <<<<");
    console.log("info: ", info);
    /*
    switch (info.columnKey){
        case "estadoRow":
            conmutarElementoDestacado(componente, info.objeto.codigo); break;
    }
    */
    if (onDobleClick) // Funcion pasada en las properties del renderGrid
        onDobleClick(info);
    else {
        if ('gridOnDobleClick' in componente)
            componente.gridOnDobleClick(info);
    }
}


export const renderTabla= (componente, datos, onAccion, propiedades) => {
    const {cargandoDatos, marcaTiempo, elementoSeleccionado} = componente.state;

    let mostrarEliminar= true;
    let mostrarBotonNuevo= true;
    let estilizadorRow= undefined;
    let alto= 600;
    if (propiedades){
        if (propiedades.mostrarEliminar !== undefined)
            mostrarEliminar= Boolean(propiedades.mostrarEliminar);
        if (propiedades.mostrarBotonNuevo !== undefined)
            mostrarBotonNuevo= Boolean(propiedades.mostrarBotonNuevo);
        if (propiedades.alto !== undefined)
            alto= propiedades.alto;

        estilizadorRow= propiedades.estilizadorRow;
    }

    let showAcciones=[BOTONERA_REFRESCAR, BOTONERA_ACCION_EXCEL];
    if (Boolean(mostrarBotonNuevo))
        showAcciones.push(BOTONERA_ACCION_NUEVO);

    let mostrarBotonera= true;
    if (propiedades && propiedades.mostrarBotonera !== undefined)
        mostrarBotonera= Boolean(propiedades.mostrarBotonera);

    let gridHeight= 600;
    if (propiedades && propiedades.height !== undefined)
        gridHeight= propiedades.height;

    //console.log(">>>> RENDERGRID");
    //console.log("componente: ", componente);
    //console.log("columnas: ", componente.columnas);

    let onElementoSeleccionado= propiedades ? propiedades.onElementoSeleccionado : null;

    return (
        <>
            {cargandoDatos &&  <Spinner intent={Intent.PRIMARY} size={50} /> }
            {(!cargandoDatos && datos) &&
                <>
                    <Tabla
                             columnas={componente.columnas}
                             datos={datos}
                             alto={alto}

                             onSelectedRow={(elemento) => {
                                 componente.setState({elementoSeleccionado: elemento});
                                 onElementoSeleccionado && onElementoSeleccionado(elemento);
                             }}
                             mostrarEliminar={mostrarEliminar}
                             onEliminar={(elemento) => handleDelete(componente, null, elemento)}
                             estilizadorRow={propiedades.estilizadorRow}
                    />
                    {Boolean(mostrarBotonera)&&
                        <FormularioBotonera
                            numElementos={datos ? datos.length : 0}
                            showAcciones={showAcciones}
                            onAccion={onAccion}
                            elementoSeleccionado={elementoSeleccionado}
                        />
                    }
                </>
            }
        </>
    );

}

export const showSecciones= (elemento, secciones, componente) => {
    return (
        secciones.map ((seccion, index) => {
            let visible= true;
            if (seccion.onVisible)
                visible= seccion.onVisible(elemento);
            if (Boolean(visible))
                return showSeccion(elemento, seccion, componente);
        })
    );
}
export const showSeccion= (elemento, seccion, componente) => {
    return (
        <div className="fr_seccion">
            {seccion.titulo &&
                <div className="fr_seccion_titulo">{seccion.titulo}</div>
            }
            <div className="fr_seccion_contenedor">
                {
                    seccion.campos.map( (campo, index) => {
                        return showCampo(elemento, campo, componente);
                    })
                }
            </div>
        </div>
    )
}

export const showEspacio= (numColumnas) => {
    let className = "fr_campo_contenedor fr_" + numColumnas + "_col";
    return (
        <div className={className}>
            <label>ESPACIO</label>
        </div>
    );
}
export const showCampo= (elemento, campo, componente) => {
    let className = "fr_campo_contenedor fr_" + campo.cols + "_col";
    let tituloReal= campo.obligatorio && campo.obligatorio == true ? campo.titulo + " *" : campo.titulo;
    let visible= campo.esVisible ? campo.esVisible(elemento) : true;

    /*
    {campo.tipo != COMPONENTE_TIPO_FOREIGN_SERVIDOR &&
     <label className="fr_campo_label">{campo.titulo}</label>
    }
    */

    if (visible) {
        return (
            <div className={className}>
                <label className="fr_campo_label">{tituloReal}</label>
                {showComponente(elemento, campo, componente)}
            </div>
        );
    }
    else{
        if (Boolean(campo.noVisibleMostrarEspacio)){
            return (
                <div className={className}>
                    <label className="fr_campo_label"></label>
                </div>
            );
        }
    }
}
export const showComponente= (elemento, campo, componente ) => {
    //console.log(">>>>>> showComponente <<<<<<<<<<<<<<<<");
    //console.log("elemento: ", elemento);
    //console.log("campo: ", campo);

    switch (campo.tipo){
        case COMPONENTE_TIPO_INPUT: return showInput(elemento, campo, componente);
        case COMPONENTE_TIPO_FLOTANTE: return showFlotante(elemento, campo, componente);
        case COMPONENTE_TIPO_SELECT: return showSelect(elemento, campo, componente);
        case COMPONENTE_TIPO_SELECT_MULTI: return showSelectMulti(elemento, campo, componente);
        case COMPONENTE_TIPO_MEMO: return showMemo(elemento, campo, componente);
        case COMPONENTE_TIPO_BOOL: return showBool(elemento, campo, componente);
        case COMPONENTE_TIPO_DATE: return showDate(elemento, campo, componente);
        case COMPONENTE_TIPO_DATETIME: return showDateTime(elemento, campo, componente);
        case COMPONENTE_TIPO_FOREIGN: return showForeign(elemento, campo,  componente);
        case COMPONENTE_TIPO_FOREIGN_SERVIDOR: return showForeignServidor(elemento, campo, componente);
        case COMPONENTE_TIPO_FOREIGN_PANTALLA: return showForeignPantalla(elemento, campo, componente);
        case COMPONENTE_TIPO_CODIGOID: return showCodigoId(elemento, campo, componente);
        case COMPONENTE_TIPO_FECHA: return showFecha(elemento, campo, componente);
        case COMPONENTE_TIPO_IDFISCAL: return showIdFiscal(elemento, campo, componente);
        case COMPONENTE_TIPO_POBLACION: return showPoblacion(elemento, campo, componente);
        case COMPONENTE_TIPO_COLOR: return showColor(elemento, campo, componente);
        case COMPONENTE_TIPO_HTML: return showHTML(elemento, campo, componente);
    }
}

//export const showInput= (elemento, nombreCampo, tab,  componente) => {
export const showInput= (elemento, campo,  componente) => {
    //console.log(">>> showInput");
    //console.log("campo.campo: ", campo.campo);
    //console.log("campo: ", campo)
    /*
    return (
        <input name={campo.campo} className="fr_componente" type="text"
               value={getValorCampo(elemento, campo.campo, "")}
               onChange={ (event) => changeElemento(componente, campo, event)}
               ref={ getTab(campo.tab, componente)}
               onKeyDown={(e) => onKeyDown(componente, e, campo.tab)}
               readOnly={campo.readOnly}
               {...(campo.maxTamagno && campo.maxTamagno > 0 ? { maxLength: campo.maxTamagno} : {})} // 👈 Asignamos tamagno máximo
        />);
     */
    return (
        <InputTexto name={campo.campo} className="fr_componente"
                    value={getValorCampo(elemento, campo.campo, "")}
                    onChange={ (event) => changeElemento(componente, campo, event)}
                    ref={ getTab(campo.tab, componente)}
                    onKeyDown={(e) => onKeyDown(componente, e, campo.tab)}
                    readOnly={campo.readOnly}
                    maxTamagno={campo.maxTamagno && campo.maxTamagno > 0 ? campo.maxTamagno :  0}
        />);
}

export const showCodigoId= (elemento, campo,  componente) => {
    //console.log(">>> showCodigoId");
    //console.log("campo.campo: ", campo.campo);
    //console.log("valor: ", getValorCampo(elemento, campo.campo, ""));
    //console.log("campo: ", campo)
    return (
        <InputCodigoId
            valor={getValorCampo(elemento, campo.campo, "")}
            onChange={ (valor) => changeElemento(componente, campo, {target: {name: campo.campo, value: valor}})}
            maxLength={5}
            padWithZeros={true} />
    );
}

export const showIdFiscal= (elemento, campo,  componente) => {
    //console.log(">>> showCodigoId");
    //console.log("campo.campo: ", campo.campo);
    //console.log("valor: ", getValorCampo(elemento, campo.campo, ""));
    //console.log("campo: ", campo)
    return (
        <InputIdFiscal
            valor={getValorCampo(elemento, campo.campo, "")}
            onChange={ (valor) => changeElemento(componente, campo, {target: {name: campo.campo, value: valor}})}
            />
    );
}

export const showFecha= (elemento, campo,  componente) => {
    //console.log(">>> showFecha");
    //console.log("campo.campo: ", campo.campo);

    //console.log("campo: ", campo)
    //El valor llega como un timestamp o como una cadena de fecha inversa.
    //El componente lo necesita como dd/mm/yyyy
    let valorDeCampo= getValorCampo(elemento, campo.campo, "");
    //console.log("valorDeCampo: ", valorDeCampo);
    return (
        <InputFecha
            valor={valorDeCampo}
            onChange={ (valor) => changeElemento(componente, campo, {target: {name: campo.campo, value: valor}})}
            autocompletarAgno={false}

            />
    );
}

export const showFlotante= (elemento, campo, componente) => {
    //console.log(">>>>>> showMoneda");
    //console.log("componente: ", componente);
    //console.log("campo.campo", campo.campo);
    //console.log("campo.tab", campo.tab);
    //console.log("componente.tabs: ", componente.tabs);
    let rawValue= getValorCampo(elemento, campo.campo, 0);
    return <InputFlotante value={rawValue} tipo={campo.tipoFlotante}
                          onChange={ (newRawValue) => changeMoneda(componente, campo, newRawValue)}/>
}

export const showDate= (elemento, campo, componente) => {
    //console.log("SHOWDATE");
    //console.log("campo: ", campo);
    let valorTimestamp= getValorCampo(elemento, campo.campo, "");
    //console.log("valorTimestamp: ", valorTimestamp);
    let valorDate= dateToInputValue(valorTimestamp);
    //console.log("valorDate: ", valorDate);
    return (
        <input name={campo.campo} className="fr_componente" type="date"
               value={valorDate || "" }
               onChange={(event) => changeElemento(componente, campo, event)}
               ref={ getTab(campo.tab, componente)}
               onKeyDown={(e) => onKeyDown(componente, e, campo.tab)}
               readOnly={campo.readOnly}
        />);
}

//El componente input date solo soporta como valor cadenas del tipo "yyyy-MM-dd"
function dateToInputValue(dateValue) {
    if (!dateValue) return "";

    const d = new Date(dateValue);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export const showDateTime= (elemento, campo, componente) => {
    console.log("SHOWDATETIME ", campo.campo);
    //El valor llega de la BDD en tiemestamp
    let valorTimestamp= getValorCampo(elemento, campo.campo, "");
    console.log("valorCampo: ", valorTimestamp);
    let valorDate= new Date(valorTimestamp);
    console.log("valorDate:", valorDate);
    return (
        <SelectorFechaHora dtFechahoraInicial={valorDate}
                           horaInicial={"08:00"} horaFinal={"21:00"} intervaloMinutos={15} fechaReadOnly={campo.fechaReadOnly}
                  onChange={(dtDatetime) => changeDateTime(componente, campo, dtDatetime.getTime())}         />
    )
}

export const showPoblacion= (elemento, campo,  componente) => {
    //console.log(">>> showPoblacion");
    //console.log("campo.campo: ", campo.campo);
    //console.log("valor: ", getValorCampo(elemento, campo.campo, ""));
    //console.log("campo: ", campo)
    return (
        <InputPoblacion
            valor= { getValorCampo(elemento, campo.campo, "") }
            onSelect={(valor) => changeElemento(componente, campo, {target: {name: campo.campo, value: valor}})}
            width="400px"
            debounce={500}
            placeholder="Escribe una población..."
        />

    );
}

export const showColor= (elemento, campo,  componente) => {
    //console.log(">>> showColor");
    //console.log("campo.campo: ", campo.campo);
    //console.log("valor: ", getValorCampo(elemento, campo.campo, ""));
    //console.log("campo: ", campo)
    return (
        <InputColor
            color= { getValorCampo(elemento, campo.campo, "") }
            onChange={(valor) => changeElemento(componente, campo, {target: {name: campo.campo, value: valor}})}
        />

    );
}

export const showSelect= (elemento, campo, componente) => {
    let valorReal= getValorCampo(elemento, campo.campo, "");
    if (!valorReal && campo.valorDefecto)
        valorReal= campo.valorDefecto;


    return (
        <select name={campo.campo} className="fr_componente"
                value={valorReal}
            //onChange={(event) => changeElemento(componente, event)}
                onChange={(event) => changeSelect(componente, campo, event)}
                ref={getTab(campo.tab, componente)}
                onKeyDown={(e) => onKeyDown(componente, e, campo.tab)}
        >
            {campo.valores.map((valor, index) => {
                return <option value={valor.codigo}>{valor.nombre}</option>
            })

            }
        </select>
    )

}

export const showSelectBusqueda = (nombre, titulo, valor, valores, onChange) => {
    return (
        <div className="fr_campo_contenedor_buscador">
            <label className="fr_campo_label">{titulo}</label>
            <select
                name={nombre}
                value={valor ?? ""}   // si valor es null, usa ""
                onChange={(event) => onChange && onChange(event.target.value || null)}
            >
                {/* opción vacía siempre visible */}
                <option value="">-- Seleccione --</option>

                {valores.map((valor, index) => {
                    return <option value={valor.codigo}>{valor.nombre}</option>
                })
                }

            </select>
        </div>
    )
}


export const showInputBusqueda= (nombre, titulo, valor, onChange, onBuscar, ref) => {
    return (
        <div className={"fr_campobusqueda_contenedor"}>
            <label className="fr_campo_label">{titulo}</label>
            <input name={nombre} className="fr_componente" type="text"
               value={valor}
               onChange={ (event) => {onChange && onChange(event.target.value) } }
               onKeyDown={(e) => {
                   if (e.key === "Enter")
                       onBuscar && onBuscar();
               }}
               ref={ref}
            />
        </div>
    )
}


export const showSelectMulti= (elemento, campo, componente) => {
    /*
    console.log("+++ showSelectMulti: ");
    console.log("campo.campo", campo.campo)
    console.log("valores: ", campo.valores);
    console.log("elemento: ", elemento);
    console.log("elemento[campo]: ", elemento[campo.campo]);
     */
    if (campo.valores && campo.valores.length >0)
        return (
            <MultiSelect options={campo.valores} label="Selecciona"
                         codigosIniciales={elemento[campo.campo]}
                         onChange={ (valor) => changeElemento(componente, campo.campo,{target: {name: campo.campo, value: valor}})  }/>
        )
    else
        return <></>
}

export const showMemo= (elemento, campo, componente) => {
    return (
        <InputTextArea valor={getValorCampo(elemento, campo.campo, "")}
                       onChange={(valor) => changeElemento(componente, campo, {target: {name: campo.campo, value: valor}})}
                       numRows={campo.rows}       />);
}

export const showHTML= (elemento, campo, componente) => {
    console.log("ShoHTML");
    console.log("elemento: ", elemento);
    let texto= getValorCampo(elemento, campo.campo, "");
    console.log("texto1: ", texto);

    return (
        <HTMLEditorQuill texto={getValorCampo(elemento, campo.campo, "")} height={200} backgroundColor={"white"}
                       onChange={(valor) => changeElemento(componente, campo, {target: {name: campo.campo, value: valor}})}
        />);

    /*
    return (
        <HTMLEditorTinyMCE texto={getValorCampo(elemento, campo.campo, "")} height={200} backgroundColor={"white"}
                         onChange={(valor) => changeElemento(componente, campo, {target: {name: campo.campo, value: valor}})}



        />);
     */
}


export const showBool= (elemento, campo, componente) => {
    return (
        <input className="fr_checkbox" type="checkbox" id="activo" name={campo.campo}
               checked={getValorCampo(elemento, campo.campo, false)}
               onChange={ (event) => {
                   console.log("event: ", event);
                   changeCheck(componente, campo, event)
               }}
        />
    );
}

// -------------------------------------------------------------------------------------------------------------------
// FOREIGN
// -------------------------------------------------------------------------------------------------------------------

export const cargarCampoForeign= (elementoConfig, nombreCampo, valores) => {
    //console.log("> cargarCampoForeign ", nombreCampo);
    for (const seccion of elementoConfig.secciones) {
        //console.log("Seccion: ", seccion);
        for (const campo of seccion.campos) {
            //console.log("campo: ", campo);
            if (campo.campo === nombreCampo) {
                campo.valores= valores;
                console.log("Modificado: ", campo);
                return campo;
            }
        }
    }
    return null; // Retorna null si no encuentra el campo
}

export const loadForeignOld= (componente, nombreClase, nombreCampoDestino, elementoConfigDestino, callback) => {
    //console.log("LOAD FOREIGN ", nombreClase);
    let url= servidor + servicioRestfulMinimo + "list/" + nombreClase;
    let parametros= { }
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost( parametros,response => {
        let datos= response;
        //console.log("Foreigns: ", datos);
        cargarCampoForeign(elementoConfigDestino, nombreCampoDestino, datos);
        //Forzamos el repintado del componente para que llame a Render con los valores correctos del Foreign
        componente.setState(prevState => ({ ...prevState }));
        callback && callback();
    });
}

export const loadForeign= (componente, nombreClase, nombreCampoDestino, elementoConfigDestino, campoOrden, callback) => {
    //console.log("LOAD FOREIGN ", nombreClase);
    let url= servidor + servicioRestfulMinimo + "listejpa/" + nombreClase;

    let condiciones= "codigo > 0";
    if (campoOrden)
        condiciones += " ORDER BY " + campoOrden;
    let parametros= {
        condiciones: condiciones
    }
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost( parametros,response => {
        let datos= response;
        //console.log("Foreigns: ", datos);
        cargarCampoForeign(elementoConfigDestino, nombreCampoDestino, datos);
        //Forzamos el repintado del componente para que llame a Render con los valores correctos del Foreign
        componente.setState(prevState => ({ ...prevState }));
        callback && callback();
    });
}

const changeForeign= (componente, campo, event) => {
    const { value } = event.target;
    //console.log(">>>>> ChangeForeign <<<<<<");
    //console.log("values: ", campo.valores);
    //console.log("event.target: ", event.target);

    let objeto= primerElementoCodigo(campo.valores, value);
    //console.log("objeto seleccionado: ", objeto);
    changeElemento(componente, campo, event, objeto);
}

export const showForeign= (elemento, campo, componente) => {

    /*
    console.log("<<<<<ShowForeign>>>>> ", campo.campo);
    console.log("elemento: ", elemento);
    console.log("values: ", campo.valores);
    console.log("valorDefecto:", campo.valorDefecto);
    console.log('campo.onCalcularOption: ', campo.onCalcularOption);
    */

    let valorReal= getValorCampo(elemento, campo.campo + ".codigo", "");
    //console.log("valorReal: ", valorReal);
    if (!valorReal && campo.valorDefecto)
        valorReal= campo.valorDefecto;
    //console.log("valorReal: ", valorReal);

    if (campo.valores && campo.valores.length >0) {
        return (
            <select name={campo.campo} className="fr_componente"
                    value={valorReal}
                    onChange={(event) => changeForeign(componente, campo, event)}
                    ref={ getTab(campo.tab, componente)}
                    onKeyDown={(e) => onKeyDown(componente, e, campo.tab)}
            >
                {
                    campo.valores.map((valor, index) => {
                        let valorMostrar= valor.nombre;
                        if (campo.onCalcularOption)
                            valorMostrar= campo.onCalcularOption(valor);
                        return <option value={valor.codigo}>{valorMostrar}</option>
                    })
                }
            </select>
        )
    }
    else
        return <></>
}

// -------------------------------------------------------------------------------------------------------------------
// FOREIGN SERVIDOR
// -------------------------------------------------------------------------------------------------------------------

const changeForeignServidor= (componente, campo, objeto) => {
    //console.log(">>>>> ChangeForeignServidor <<<<<<");
    //console.log("objeto: ", objeto);
    //Componemos el objeto evento, para inyectar el name igual que hacen los otros inputs y poder pasarlo de parametro a changeElemento.
    let evento= {target: {name: campo.campo}};
    //console.log("evento: ", evento);
    changeElemento(componente, campo, evento, objeto, () => campo.onChange && campo.onChange(objeto) );
}


export const showForeignServidor= (elemento, campo, componente) => {
    //const {urlServicioRestful, tabOrderManager} = this.props;
    //console.log("showForeignServidor");
    //console.log("elemento: ", elemento);
    //console.log("campo: ", campo);

    let urlServicioRestful = servidor + servicioRestfulMinimo;
    const campoValor= campo.campoValor? campo.campoValor: "codigo";
    const campoMostrar= campo.campoMostrar ? campo.campoMostrar : "nombre";
    const campoTitulo = campo.campoTitulo ? campo.campoTitulo : "Nombre";
    const campoIdMostrar= campo.mostrarCampoId ? "codigoid" : null;
    const campoIdTitulo= campo.campoIdTitulo;
    const mostrarTitulo=  campo.mostrarTitulo == null || Boolean(campo.mostrarTitulo);
    let valor= elemento[campo.campo];
    let valorInicial= null;

    return <SelectorListaClaseObjeto key={campo.campo}
                              urlServicioRestful={urlServicioRestful}
                              clase={campo.clase}
                              titulo=""
                              campoValor= {campoValor}
                              campoMostrar= {campoMostrar}
                              campoTitulo={campoTitulo}
                              campoIdMostrar= {campoIdMostrar}
                              campoIdTitulo={campoIdTitulo}
                              valor={valor ? valor : {}}
                              valorInicial={valorInicial}
                              icon={campo.icon}
                              onElementoChanged={(objeto) => {
                                  if (elemento)
                                      changeForeignServidor(componente, campo, objeto);
                                  else
                                      changeForeignServidor(componente, campo,null);
                                }
                              }
                              campoNombre={campo.campo}
    />
}

const changeForeignPantalla= (componente, campo, objeto) => {
    //console.log(">>>>> ChangeForeignPantalla <<<<<<");
    //console.log("objeto: ", objeto);
    //Componemos el objeto evento, para inyectar el name igual que hacen los otros inputs y poder pasarlo de parametro a changeElemento.
    let evento= {target: {name: campo.campo}};
    //console.log("evento: ", evento);
    changeElemento(componente, campo, evento, objeto, () => campo.onChange && campo.onChange(objeto) );
}

export const showForeignPantalla= (elemento, campo, componente) => {
    //console.log("showForeignServidor");
    //console.log("elemento: ", elemento);
    //console.log("campo: ", campo);

    const campoValor= campo.campoValor? campo.campoValor: "codigo";
    const campoMostrar= campo.campoMostrar ? campo.campoMostrar : "nombre";
    let o= elemento[campo.campo];
    return <SelectorClaseObjeto key={campo.campo}
                                campoValor= {campoValor}
                                campoMostrar= {campoMostrar}
                                elemento={o ? o : {}}
                                icon={campo.icon}
                                formulario={campo.formulario}
                                onElementoChanged={(objeto) => {
                                    console.log(" ??????? FORMULARIOUTILS - onElementoChanged ??????");
                                    console.log("objeto: ", objeto);
                                    if (elemento)
                                        changeForeignPantalla(componente, campo, objeto);
                                    else
                                        changeForeignPantalla(componente, campo,null);
                                    }
                                }

     />
}


// -------------------------------------------------------------------------------------------------------------------
// DATOS
// -------------------------------------------------------------------------------------------------------------------
export const loadDatos= (componente, nombreClase, callback) => {
    componente.setState({cargandoDatos: true});
    //let url= servidor + servicioRestfulMinimo + "list/" + nombreClase;
    let url= servidor + servicioRestfulMinimo + "listejpa/" + nombreClase;
    let parametros= {
        condiciones: "codigo > 0",
        orden: "nombre ASC",
    }

    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost({},response => {
        let datos= response;
        datos.forEach((dato, item) => {
            dato.estadoModificacion= "";
        });
        console.log("Datos: ", datos);
        componente.setState({datos: datos, cargandoDatos: false}, () => { callback && callback()});
    });
}

export const postServicio= (componente, nombreClase, servicio, parametros, callback) => {
    componente.setState({cargandoDatos: true});
    let url= servidor + servicioRestfulMinimo + "servicio/" + nombreClase + "/" + servicio;
    console.log("loadDatosServicio ", url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost( parametros,response => {
        console.log("response: ", response);
        componente.setState({cargandoDatos: false}, () => { callback && callback(response)});
    });
}

export const postServicioBloqueante = async (nombreClase, servicio, parametros) => {
    let url= servidor + servicioRestfulMinimo + "servicio/" + nombreClase + "/" + servicio;
    console.log("postServicioBloqueante ", url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    try {
        const respuesta = await clienteRestful.doPostBloqueante(parametros);
        console.log("respuesta: ", respuesta);
        return respuesta;
    } catch (error) {
        console.error("Error al guardar:", error);
    }
}

export const loadDatosServicio= (componente, nombreClase, servicio, parametros, callback, callbackError) => {
    componente.setState({cargandoDatos: true});
    let url= servidor + servicioRestfulMinimo + "servicio/" + nombreClase + "/" + servicio;
    console.log("loadDatosServicio ", url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost( parametros,response => {
        console.log("response: ", response);
        let datos= response;
        datos.forEach((dato, item) => {
            dato.estadoModificacion= "";
        });

        console.log("Datos: ", datos);

        componente.setState({datos: datos, cargandoDatos: false}, () => { callback && callback(datos)});
        },
        () => {
            callbackError && callbackError();
        }
    );
}

export const loadDato= (componente, nombreClase, codigo, callback) => {
    componente.setState({cargandoDatos: true});
    let url= servidor + servicioRestfulCompleto  + nombreClase + "/" + codigo.toString();

    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doGet(response => {
        let dato= response;
        console.log("Dato: ", dato);
        componente.setState({elementoSeleccionado: dato, cargandoDatos: false}, () => { callback && callback()});
    });
}

export const loadDatosURL= (componente, url, parametros, callback) => {
    componente.setState({cargandoDatos: true});
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost(parametros,response => {
        let datos= response;
        console.log("Dato: ", datos);
        componente.setState({datos: datos, cargandoDatos: false}, () => { callback && callback(datos)});
    });
}


// -------------------------------------------------------------------------------------------------------------------
// ACCIONES
// -------------------------------------------------------------------------------------------------------------------

export const guardar= (elemento, usuarioCodigo, elementoConfig, onGuardado) => {

    //Comprobamos si es válido
    if (!validar(elemento, elementoConfig))
        return;

    let elementoPreparado= {...elemento};
    console.log("Guardar!");
    console.log("elementoConfig.className: ", elementoConfig.className);
    console.log("elementoPreparado:", elementoPreparado);

    if (elementoConfig.className){
        let url= servidor + servicioRestfulMinimo + elementoConfig.className + "/" + usuarioCodigo;
        const clienteRestful = new ClienteRestful().setUrl(url);
        console.log("url: ", url);
        clienteRestful.doPost(elementoPreparado, response => {
            let elementoGuardado= response;
            console.log("response: ", response);
            if (clienteRestful.exito && response) {
                //onGuardado && onGuardado(elementoCompleto);
                console.log("Guardado!");
                onGuardado && onGuardado(elementoGuardado);
            }
        });
    }

}

//El componente tiene que tener las columnas definidas dentro (this.columnas)
export const exportarExcel= (elemento, componente) => {
    const {datos} = componente.state;
    if (componente.columnas && datos)
        exportarExcelLocal(calcularDatosConPie(this.columnas, datos), this.columnas);
}

// -------------------------------------------------------------------------------------------------------------------
// CAMPOS OBLIGATORIOS
// -------------------------------------------------------------------------------------------------------------------
/*
export const validarOld= (elemento, elementoConfig) => {
    let aCamposTitulosInvalidos= [];
    //console.log(">>> Validar <<<");
    //1. Obtenemos los campos obligatorios
    for (const seccion of elementoConfig.secciones) {
        for (const campo of seccion.campos) {
            //console.log("campo.campo:", campo.campo);
            if (campo.obligatorio &&  campo.obligatorio === true) {
                //Comprobamos si tiene valor
                let valor= getValorCampo(elemento, campo.campo);
                //console.log("valor: ", valor);
                if (estaVacia(valor))
                    aCamposTitulosInvalidos.push(campo.titulo);
            }
        }
    }

    if (aCamposTitulosInvalidos.length > 0) {
        const mensaje = "Los siguientes campos obligatorios no se han completado: " + aCamposTitulosInvalidos.join(", ");
        AvisoModalServicio.showAviso(mensaje);
        //alert(mensaje);
        return false;
    }

    return true;
}
*/

export const validar = (elemento, elementoConfig) => {
    const camposObligatorios = [];
    const camposLongitud = [];

    console.log(">>> Validar <<<");

    for (const seccion of elementoConfig.secciones) {
        for (const campo of seccion.campos) {
            const valor = getValorCampo(elemento, campo.campo);
            // Comprobación de obligatorios
            if (campo.obligatorio === true && estaVacia(valor)) {
                camposObligatorios.push(campo.titulo);
            }


            // Comprobación de longitud máxima
            /*
            if (campo.tamaximo != null && valor != null &&  valor !== "" ) {
                const texto = String(valor);
                if (texto.length >  campo.tamaximo) {
                    camposLongitud.push( `${campo.titulo} (${texto.length}/${campo.tamaximo})` );
                }
            }
          */
            // Comprobación de longitud máxima más robusta
            const tamMaximo = Number(campo.tamaximo);
            if (
                !Number.isNaN(tamMaximo) &&
                valor != null &&
                valor !== "" &&
                String(valor).length > tamMaximo
            ) {
                camposLongitud.push(`${campo.titulo} (${String(valor).length}/${tamMaximo})`);
            }
        }
    }
    const mensajes = [];
    if (camposObligatorios.length > 0)
        mensajes.push( "Los siguientes campos obligatorios no se han completado: " + camposObligatorios.join(", ")  );

    if (camposLongitud.length > 0)
        mensajes.push( "Los siguientes campos superan la longitud máxima permitida: " +  camposLongitud.join(", ") );
    if (mensajes.length > 0) {
        AvisoModalServicio.showAviso(mensajes.join("\n\n"));
        return false;
    }
    return true;
};

function estaVacia(valor) {
    if (valor == null) return true; // null o undefined
    if (typeof valor === "string") return valor.trim() === "";
    if (typeof valor === "number") return false;
    return false; // otros tipos no se consideran vacíos
}

//------------------------------------------------------------------------------------------------------------------
// GUARDADO DE ROWS
//------------------------------------------------------------------------------------------------------------------

export const onRowModificada = (componente, objetoNew, rowIndex, callback) => {
    console.log("* onRowModificada");
    console.log("elementoConfig: ", componente.elementoConfig);
    console.log("objetoNew: ", objetoNew);
    console.log("rowIndex: ", rowIndex);

    //Comprobamos que estén todos los campos obligatorios rellenos:
    if (validar(objetoNew, componente.elementoConfig)){
        guardarRow(componente, objetoNew, rowIndex, callback);
        return true;
    }
    else{
        return false;
    }
}


export const guardarRow= (componente, objetoNew, rowIndex, callback) => {
    const {datos} = componente.state;
    const {auth} = componente.props;

    console.log("FORMULARIOGRID GUARDARROW");
    console.log("obetoNew: ", objetoNew);
    console.log("auth: ", auth);
    //Obtenemos el codigo de usuario
    let usuarioCodigo= auth.usuario ? auth.usuario.codigo : 0;

    //Eliminamos los campos artificiales
    let elementoPreparado= {...objetoNew};
    delete elementoPreparado.nivel;
    delete elementoPreparado.modificado;
    delete elementoPreparado.guardado;
    delete elementoPreparado.estadoRow;
    delete elementoPreparado.filaSeleccionada;
    delete elementoPreparado.rowIdx;

    let nuevo= elementoPreparado.codigo == 0;

    let elementoConfig= componente.elementoConfig;
    let urlPost= servidor + servicioRestfulCompleto + elementoConfig.className + "/" + usuarioCodigo;
    console.log("urlPost: ", urlPost);
    //let urlPost= elementoConfig.url + elementoConfig.className + "/" + usuarioCodigo;;
    const clienteRestful = new ClienteRestful().setUrl(urlPost);
    clienteRestful.doPost(elementoPreparado, response => {
        if (clienteRestful.exito && response) {
            if(nuevo){
                datos.push(response);
                this.setState({datos: datos}, () => {
                    callback(response, rowIndex, true);
                });
            }
            else {
                //sustituir el row;
                let pos= posPrimerElementoConValorPropiedad(datos, "codigo", elementoPreparado.codigo);
                datos[pos]= response;
                callback(response, rowIndex, true);
            }
        }
        else{
            callback(response, rowIndex, false);
        }
    });


}


// --------------------------------------------------------------------------------------------------------------
// CARGA DE VALORES
// --------------------------------------------------------------------------------------------------------------

export const cargarValoresColumna= (columnas, campo, valores) => {
    //console.log("XXXXXXXXXXXXX  cargarValoresColumna XXXXXXXXXXXXXX ")
    let newColumnas=  columnas.map(columna => {
        if (columna.campo === campo) {
            return {
                ...columna,
                valores: valores
            };
        }
        return columna;
    });

    //console.log("newColumnas: ", newColumnas);
    return newColumnas;
}
// --------------------------------------------------------------------------------------------------------------

export const asignarValoresCampo = (elementoConfig, tituloSeccion, campo, valores) => {
    const seccion = elementoConfig.secciones.find(
        s => s.titulo === tituloSeccion
    );
    if (!seccion)
        return false;

    const campoConfig = seccion.campos.find(
        c => c.campo === campo
    );
    if (!campoConfig)
        return false;

    campoConfig.valores = valores;
    return true;
};